import { useTranslation } from 'react-i18next';
import React from 'react';
import { clearFreshSignup } from '../utils/signupGate';

/**
 * Shown ONLY to a brand-new signup on an actual mobile device, before onboarding.
 * Hard stop — there is no "continue" on mobile; the user must finish setting up on
 * a desktop/laptop (log in there with the same account). Log out is the only exit,
 * so the user is never trapped. Rendered app-wide by AdminApp, so no route can
 * bypass it. "AeroChat" is the brand name and is never translated.
 */
export default function DesktopOnlyGate({ onLogout }) {
  const { t } = useTranslation('onboarding');

  const handleLogout = () => {
    clearFreshSignup();
    if (onLogout) onLogout();
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: '#FEFCFA' }}>
      <div style={{ maxWidth: 380, width: '100%', textAlign: 'center', background: '#fff', borderRadius: 16, padding: '36px 28px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        <div style={{ fontSize: 48, lineHeight: 1, marginBottom: 16 }} aria-hidden="true">🖥️</div>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1f2937', margin: '0 0 12px' }}>
          {t('desktopGate.title', 'Please continue on a desktop')}
        </h1>
        <p style={{ fontSize: 15, color: '#4b5563', lineHeight: 1.5, margin: '0 0 10px' }}>
          {t('desktopGate.body', 'For the best experience, please finish setting up your account on a desktop or laptop.')}
        </p>
        <p style={{ fontSize: 13.5, color: '#6b7280', lineHeight: 1.5, margin: '0 0 24px' }}>
          {t('desktopGate.hint', 'Open AeroChat on your computer and log in with the same account to continue.')}
        </p>
        <button
          type="button"
          onClick={handleLogout}
          style={{ border: '1px solid #e5e7eb', background: '#fff', color: '#dc2626', fontSize: 14, fontWeight: 600, padding: '10px 20px', borderRadius: 10, cursor: 'pointer' }}
        >
          {t('desktopGate.logout', 'Log out')}
        </button>
      </div>
    </div>
  );
}
